import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import { getServerNameCode } from '../../config/gcs/gcsConfigs';
import { CenterOpenState } from '../../types/gcs/center';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';

interface ConfirmOpenServiceDialogProps {
  gcsId: string;
  onClose: () => void;
}

function ConfirmOpenServiceDialog({ gcsId, onClose }: ConfirmOpenServiceDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [submitAction, setSubmitAction] = useState<AsyncAction>(AsyncAction.initial());
  const setCenterOpenState = useGcsStore((state) => state.setCenterOpenState);
  const nameCode = getServerNameCode(gcsId);

  const onConfirmClicked = async () => {
    try {
      setSubmitAction(AsyncAction.loading());
      await setCenterOpenState(gcsId, CenterOpenState.CENTER_OPEN);
      setSubmitAction(AsyncAction.success());
      onClose();
    } catch (error) {
      setSubmitAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmOpenServiceDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmOpenServiceDialog.confirmOpenServiceButton,
        callback: onConfirmClicked,
        isLoading: submitAction.isLoading
      }}
      errorText={submitAction.isFailure ? getLocalizedErrorMessage(submitAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmOpenServiceDialog.body.replace('{nameCode}', nameCode)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmOpenServiceDialog;
